module.exports = __webpack_public_path__ + "img/7.a95addb0.jpg";